
<ul
  class="dropdown-menu"
  v-on="$listeners"
  :style="{ '--dropdown-menu-height': maxHeight ? `${maxHeight}px` : '300px' }"
>
  <li v-show="options.length === 0 && !hideNoResults">
    <span>No results</span>
  </li>

  <li
    v-for="({ value, label, icon, marker }, index) in options"
    :key="value"
    :class="{ active: activeValue === value, focus: index === focus }"
    @click.stop.prevent="selectItem(value)"
  >
    <align justify="space-between">
      <align>
        <icon v-if="icon" :name="icon" class="icon" />
        <span>{{ label }}</span>
      </align>

      <pro-label v-if="marker">{{ marker }}</pro-label>
    </align>
  </li>
</ul>
